/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, Dispatch, SetStateAction, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { RoutesFilters } from '@types'

type ContextState = {
  filters?: RoutesFilters
  setFilters: Dispatch<SetStateAction<RoutesFilters>>
  resetFilters: () => void
}

export const initialRoutesFiltersState = {
  filters: { page: 1, limit: 10 },
  setFilters: () => {},
  resetFilters: () => {},
}

const RoutesFiltersContext = React.createContext<ContextState>(initialRoutesFiltersState)

export function RoutesFiltersProvider({ children }: { children: React.ReactNode }) {
  const [search] = useSearchParams()
  const [filters, setFilters] = useState<RoutesFilters>(initialRoutesFiltersState.filters)

  const [resetTriggered, setResetTriggered] = useState<number>(0)

  const resetFilters = () => {
    setResetTriggered(state => state + 1)
  }

  useEffect(() => {
    if (resetTriggered) {
      setFilters(initialRoutesFiltersState.filters)
    }
  }, [resetTriggered])

  useEffect(() => {
    if (filters && search.get('service')) {
      setFilters(state => ({
        ...state,
        asnum: Number(search.get('service')) ?? undefined,
        page: initialRoutesFiltersState.filters.page,
      }))
    }
  }, [search])

  return (
    <RoutesFiltersContext.Provider value={{ filters, setFilters, resetFilters }}>
      {children}
    </RoutesFiltersContext.Provider>
  )
}

export function useRoutesFilters(): ContextState {
  const context = useContext(RoutesFiltersContext)
  if (!context) throw Error('This hook can only be used under the RoutesFiltersProvider component')
  return context
}
